export * from './module-pack.js';
export * from './organization-permission-module-fe.js';
//# sourceMappingURL=index.js.map